import { controlClose, focusNextControlTrigger } from '../../../../resources/scripts/components/c-common';

export default function () {
  const userLocale = document.documentElement.lang || navigator.language || 'en-US';

  function formatMonth(date) {
    return new Intl.DateTimeFormat(userLocale, { month: 'short' }).format(date);
  }

  function save(control, datepicker) {
    const widget = control.closest('.js-booking-widget');
    const trigger = control.querySelector('.js-control-trigger');
    const badge = widget.querySelector('.js-badge-dates');

    const elementCheckin = datepicker.querySelector('.js-datepicker-checkin');
    const elementCheckout = datepicker.querySelector('.js-datepicker-checkout');

    const { checkin } = elementCheckin.dataset;
    const { checkout } = elementCheckout.dataset;

    const checkinDate = new Date(checkin);
    const checkoutDate = new Date(checkout);

    const sameMonth = checkinDate.getMonth() === checkoutDate.getMonth();
    const sameYear = checkinDate.getFullYear() === checkoutDate.getFullYear();

    let formatted;

    if (sameYear && sameMonth) {
      formatted = `${formatMonth(checkinDate)} ${checkinDate.getDate()} - ${formatMonth(checkinDate)} ${checkoutDate.getDate()}, ${checkinDate.getFullYear()}`;
    } else if (sameYear && !sameMonth) {
      formatted = `${formatMonth(checkinDate)} ${checkinDate.getDate()} - ${formatMonth(checkoutDate)} ${checkoutDate.getDate()}, ${checkinDate.getFullYear()}`;
    } else {
      formatted = `${formatMonth(checkinDate)} ${checkinDate.getDate()}, ${checkinDate.getFullYear()} - ${formatMonth(checkoutDate)} ${checkoutDate.getDate()}, ${checkoutDate.getFullYear()}`;
    }

    trigger.textContent = formatted;
    badge.textContent = formatted;
  }

  let saveButton = null;

  if (window.document.querySelector('.js-datepicker')) {
    saveButton = window.document.querySelector('.js-datepicker').querySelector('.js-datepicker-save');
  }

  if (saveButton) {
    saveButton.addEventListener('mousedown', (event) => {
      event.preventDefault();
      event.stopPropagation();
    });

    saveButton.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const { target } = event;
      const control = target.closest('.js-control');
      const datepicker = control.querySelector('.js-datepicker');
      const datepickerDaysSelected = datepicker.querySelectorAll('.js-datepicker-day.selected');
      const datepickerDaysRange = datepicker.querySelectorAll('.js-datepicker-day.range');

      if (datepickerDaysSelected.length && datepickerDaysRange.length) {
        save(control, datepicker);
        controlClose(control);
        focusNextControlTrigger(control);
      }
    });
  }

  function clear(control) {
    const widget = control.closest('.js-booking-widget');
    const badge = widget.querySelector('.js-badge-dates');
    const trigger = control.querySelector('.js-control-trigger');
    trigger.textContent = trigger.dataset.i18nLabel;
    badge.textContent = trigger.dataset.i18nLabel;

    const elementCheckin = control.querySelector('.js-datepicker-checkin');
    elementCheckin.textContent = elementCheckin.dataset.i18nLabel;
    elementCheckin.dataset.checkin = '';

    const elementCheckout = control.querySelector('.js-datepicker-checkout');
    elementCheckout.textContent = elementCheckout.dataset.i18nLabel;
    elementCheckout.dataset.checkout = '';

    const elementsDay = control.querySelectorAll('.js-datepicker-day');
    elementsDay.forEach((day) => {
      day.classList.remove('selected');
      day.classList.remove('range');
    });

    saveButton.classList.remove('show');
  }

  const clearButton = window.document.querySelector('.js-datepicker-clear');
  if (clearButton) {
    clearButton.addEventListener('mousedown', (event) => {
      event.preventDefault();
      event.stopPropagation();
    });

    clearButton.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const { target } = event;
      const control = target.closest('.js-control');

      clear(control);
    });
  }
}
